export default {
  sendmail: {
    mailHeaderTitle: 'Envoyer votre simulation par mail',
    mailHeaderExplain: 'Cette fonctionnalité vous permet de créer un fichier PDF basé sur votre calcul.',
    mailHeaderExplain2:
      'BatiKal vous permet aussi de personnaliser votre PDF en utilisant le logo de votre société, une entête personnalisée....',
    mailHeaderSeeExample: 'Voir un exemple',
    mailchooseCustom: 'Choississer les éléments de customisation de votre e-mail.',
    sendMail: 'Envoyer par e-mail',
    preview: 'Prévisualiser',
    customisationMessage: "Cliquer sur l'icône pour accéder au paramétrage des données de personnalisations",
    add_logo_top_mail: 'Ajouter votre logo en entête du mail',
    cuange_logo_top_mail: 'Mettre à jour le logo'
  },
  // Mail
  mail_conditionsDepart: 'Conditions Départ',
  mail_conditions: 'Conditions',
  mail_results: 'Résultats',
  mail_result: 'Résultat',
  mail_body: 'Veuillez trouvez ci-joint le fichier pdf de votre simulation',
  mail_pdfgeneration_error: 'Erreur lors de la génération du document. Si le problème se reproduit, contactez le support',
  mail_previewpdfgeneration_error: 'Erreur lors de la généraiton du preview',
  mail_nomprojet: 'Nom du projet',
  mail_statusprojet: 'Status du projet',
  settingsProfile_errorMail: 'Vérifiez votre configuration'
}
